module.exports = __webpack_public_path__ + "static/media/rouge.a7aaef5b.png";